import { FlightDateSave } from "../expense/flight-date-save";

export class ExpenseProduct {
    color: string;
    flightDate: Array<FlightDateSave>;
    id: number;
    notes: string;
    price: number;
    count: number;
    end: number;
    margin: string;
    priceText: string;
    showLine: boolean;
    start: number;
    widthContainer: string;
    constructor (data) {
        this.color = data.color;
        if (data.flightDate) {
            this.flightDate = data.flightDate.map((item) => new FlightDateSave(item));
        }
       
        this.id = data.id;
        this.notes = data.notes;
        this.price = data.price;
        this.count = data.count;
        this.end = data.end;
        this.margin = data.margin;
        this.priceText = data.priceText;
        this.showLine = data.showLine;
        this.start = data.start;
        this.widthContainer = data.widthContainer;

    }
}


// WEBPACK FOOTER //
// ./src/app/components/class/product/expense.ts